import { createAction } from './createAction';

export const clearCacheAction = createAction('utils/CLEAR_CACHE');
